import styled from 'styled-components';
import { Modal } from 'reactstrap';

export const ModalDeleteItemStyled = styled(Modal)`
  min-width: 30rem;

  .btn-submit {
    width: 4.5rem;
    background-color: #f46a6a;
    color: #fff !important;
    border: none;
  }
  .btn-submit:hover {
    background-color: #f23d3d;
  }

  .btn-delete {
    border: none;
    color: #f46a6a !important;

    &:hover {
      border: none !important;
    }
  }
`;
